import React, { useState, useEffect } from "react";
import { 
  Send, Image as ImageIcon, Video, Globe, AlertCircle, Settings, 
  CheckCircle, Eye, Users, Heart 
} from "lucide-react";

// PRECISE BRAND SVG DEFINITIONS (Compensating for Lucide-React v1 brand deletions)
const SparklesIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" className={className}>
    <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/>
    <path d="m5 3 1 2.5L8.5 6 6 7 5 9.5 4 7 1.5 6 4 5.5 5 3Z"/>
    <path d="m19 17 1 2.5 2.5.5-2.5 1-1 2.5-1-2.5-2.5-1 2.5-1 1-2.5Z"/>
  </svg>
);

const TwitterIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} fill="currentColor" viewBox="0 0 24 24" className={className}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const FacebookIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} fill="currentColor" viewBox="0 0 24 24" className={className}>
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const LinkedinIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} fill="currentColor" viewBox="0 0 24 24" className={className}>
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const InstagramIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" className={className}>
    <rect width="20" height="20" x="2" y="2" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
  </svg>
);

const ShareIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" className={className}>
    <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
  </svg>
);

const YoutubeIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} fill="currentColor" viewBox="0 0 24 24" className={className}>
    <path d="M23.498 6.163a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.837zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);

const WhatsappIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} fill="currentColor" viewBox="0 0 24 24" className={className}>
    <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 11.966.01c3.178.001 6.169 1.24 8.424 3.496 2.254 2.256 3.491 5.252 3.49 8.432-.005 6.61-5.342 11.948-11.913 11.948-2.006-.001-3.973-.504-5.73-1.461L0 24zm6.59-4.846l.394.233c1.498.887 3.221 1.355 4.982 1.356 5.329 0 9.665-4.336 9.669-9.664.002-2.582-1.004-5.01-2.834-6.843-1.83-1.832-4.258-2.84-6.844-2.842-5.336 0-9.677 4.338-9.68 9.671-.001 1.844.519 3.64 1.503 5.207l.264.42-1.001 3.651 3.747-.982zm10.89-6.925c-.299-.149-1.772-.874-2.047-.973-.274-.1-.474-.149-.673.149-.199.299-.773.973-.947 1.171-.175.199-.349.224-.648.075-.3-.149-1.265-.467-2.41-1.487-.89-.793-1.49-1.772-1.665-2.071-.175-.299-.019-.461.13-.609.134-.133.299-.349.448-.523.149-.174.199-.299.299-.498.1-.199.05-.373-.025-.522-.075-.149-.673-1.62-.922-2.217-.242-.581-.487-.502-.673-.512-.174-.009-.374-.01-.573-.01-.199 0-.523.075-.797.373-.274.299-1.047 1.022-1.047 2.49 0 1.468 1.069 2.889 1.219 3.088.149.199 2.103 3.211 5.098 4.503.713.308 1.269.491 1.702.629.717.227 1.369.195 1.885.118.574-.087 1.772-.724 2.021-1.42.249-.697.249-1.295.174-1.42-.075-.124-.274-.199-.573-.348z"/>
  </svg>
);

const GoogleIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} fill="currentColor" viewBox="0 0 24 24" className={className}>
    <path d="M21.35 11.1h-9.17v2.73h6.51c-.33 1.56-1.56 3.21-3.81 4.21v3.51h6.12c3.58-3.29 5.64-8.15 5.64-13.92 0-.64-.06-1.13-.15-1.53zM12.18 21.42c4.99 0 9.18-1.65 12.24-4.48l-6.12-3.51c-1.68 1.14-3.81 1.83-6.12 1.83-4.65 0-8.57-3.04-9.98-7.21H.18v3.63c3.06 6.05 9.31 9.74 15.63 9.74zm-9.98-13.37A11.82 11.82 0 0 1 1.85 12c0 1.35.23 2.65.65 3.86l-5.84 3.63c-1.32-2.63-2.07-5.59-2.07-8.71s.75-6.08 2.07-8.71l5.84 3.63zm9.98-4.4c3.46 0 5.81 1.5 7.14 2.76l5.35-5.23C21.36 1.55 17.18 0 12.18 0 5.86 0 .6 3.69-2.46 9.74l5.84 3.63c1.41-4.17 5.33-7.21 9.98-7.21z"/>
  </svg>
);

export default function AdminMarketing() {
  // UI State
  const [activeTab, setActiveTab] = useState("compose");
  const [loading, setLoading] = useState(false);
  const [configLoading, setConfigLoading] = useState(false);
  const [alert, setAlert] = useState(null);

  // Compose Form Data
  const [message, setMessage] = useState("");
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [mediaPreview, setMediaPreview] = useState(null);
  const [selectedChannels, setSelectedChannels] = useState(["facebook", "twitter", "linkedin"]);

  // Configurations
  const [configs, setConfigs] = useState({
    facebook: { enabled: false, page_access_token: "", page_id: "" },
    instagram: { enabled: false, access_token: "", business_account_id: "" },
    twitter: { enabled: false, api_key: "", api_secret: "", access_token: "", access_token_secret: "" },
    linkedin: { enabled: false, access_token: "", organization_id: "" },
    youtube: { enabled: false, client_id: "", client_secret: "", refresh_token: "" },
    whatsapp: { enabled: false, phone_number_id: "", access_token: "" },
    google: { enabled: false, location_id: "", api_key: "" }
  });

  // AI Companion & Ads Controls
  const [aiTopic, setAiTopic] = useState("");
  const [aiAudience, setAiAudience] = useState("Competitive Exam Aspirants");
  const [aiLoading, setAiLoading] = useState(false);
  const [aiSuggestions, setAiSuggestions] = useState(null);
  const [showAiHelper, setShowAiHelper] = useState(false);

  const [isAdCampaign, setIsAdCampaign] = useState(false);
  const [adBudget, setAdBudget] = useState(500);
  const [adDuration, setAdDuration] = useState(7);

  // Simulated Reach metrics
  const metrics = [
    { label: "Estimated Network Reach", val: "184.5K", icon: Eye, trend: "+14.2% this month", color: "indigo" },
    { label: "Connected Graph Hooks", val: Object.values(configs).filter(c => c.enabled).length.toString(), icon: Globe, trend: "Active across platforms", color: "emerald" },
    { label: "Engaged Impressions", val: "42.9K", icon: Heart, trend: "+8.1% lift", color: "rose" },
    { label: "Admin Broadcast Actions", val: "97", icon: Send, trend: "Social streams healthy", color: "sky" },
  ];

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:8000";
      const res = await fetch(`${baseUrl}/marketing/settings`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      });
      if (res.ok) {
        const data = await res.json();
        setConfigs(prev => ({ ...prev, ...data }));
      }
    } catch (e) {
      console.error("Error loading marketing config:", e);
    }
  };

  const handleSaveConfig = async () => {
    setConfigLoading(true);
    try {
      const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:8000";
      const res = await fetch(`${baseUrl}/marketing/settings`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
        body: JSON.stringify(configs)
      });
      if (res.ok) {
        showAlert("success", "Marketing graph configurations persisted successfully!");
      } else {
        showAlert("error", "Failed to save configuration data.");
      }
    } catch (e) {
      showAlert("error", "Connection failed when contacting API service.");
    } finally {
      setConfigLoading(false);
    }
  };

  const handleGetAISuggestions = async () => {
    if (!aiTopic.trim()) {
      showAlert("error", "Please provide a topic/prompt for AI analysis.");
      return;
    }
    setAiLoading(true);
    try {
      const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:8000";
      const res = await fetch(`${baseUrl}/marketing/ai-suggest`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
        body: JSON.stringify({ topic: aiTopic, target_audience: aiAudience })
      });
      if (res.ok) {
        const data = await res.json();
        setAiSuggestions(data);
        showAlert("success", "✨ AI Marketing engine calculated optimal targets!");
      } else {
        showAlert("error", "AI Helper temporarily down.");
      }
    } catch (err) {
      showAlert("error", "Could not connect to AI model.");
    } finally {
      setAiLoading(false);
    }
  };

  const handleMediaChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedMedia(file);
      const reader = new FileReader();
      reader.onloadend = () => setMediaPreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const toggleChannel = (id) => {
    setSelectedChannels(prev => 
      prev.includes(id) ? prev.filter(c => c !== id) : [...prev, id]
    );
  };

  const handlePublish = async () => {
    if (!message.trim()) {
      showAlert("error", "Please enter a message caption to broadcast.");
      return;
    }
    if (selectedChannels.length === 0) {
      showAlert("error", "Select at least one destination channel.");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("message", message);
    formData.append("channels_json", JSON.stringify(selectedChannels));
    
    if (isAdCampaign) {
      formData.append("ad_config_json", JSON.stringify({
        active: true,
        budget: adBudget,
        duration: adDuration,
        locations: aiSuggestions?.suggested_locations || [],
        areas: aiSuggestions?.marketing_areas || []
      }));
    }

    if (selectedMedia) {
      formData.append("media", selectedMedia);
    }

    try {
      const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:8000";
      const res = await fetch(`${baseUrl}/marketing/post`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
        body: formData
      });
      
      if (res.ok) {
        showAlert("success", "🎉 Multi-channel campaign dispatched to background API queues!");
        setMessage("");
        setSelectedMedia(null);
        setMediaPreview(null);
      } else {
        const errData = await res.json();
        showAlert("error", errData.detail || "Failed to execute social broadcast.");
      }
    } catch (e) {
      showAlert("error", "Could not reach backend broadcast engine.");
    } finally {
      setLoading(false);
    }
  };

  const showAlert = (type, text) => {
    setAlert({ type, text });
    setTimeout(() => setAlert(null), 6000);
  };

  return (
    <div className="space-y-8 pb-20 max-w-[1400px] mx-auto animate-in fade-in duration-500">
      {/* Page Header */}
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-b border-slate-200 pb-6">
        <div>
          <h1 className="text-3xl font-extrabold tracking-tight text-slate-900 flex items-center gap-3">
            <div className="p-2.5 bg-gradient-to-br from-indigo-600 to-violet-600 text-white rounded-xl shadow-md">
              <ShareIcon size={24} />
            </div>
            Unified Social Marketing Suite
          </h1>
          <p className="text-slate-500 mt-2 font-medium leading-relaxed max-w-2xl">
            Compose single posts, upload high-fidelity media and instantly broadcast across your connected global social graph APIs simultaneously.
          </p>
        </div>

        {/* Actions & Tabs */}
        <div className="flex bg-slate-100 p-1.5 rounded-xl border border-slate-200 shadow-inner">
          <button
            onClick={() => setActiveTab("compose")}
            className={`px-5 py-2.5 rounded-lg font-bold text-sm transition-all flex items-center gap-2 ${
              activeTab === "compose" 
                ? "bg-white text-indigo-600 shadow-md" 
                : "text-slate-600 hover:text-slate-900"
            }`}
          >
            <Send size={16} />
            Compose Campaign
          </button>
          <button
            onClick={() => setActiveTab("settings")}
            className={`px-5 py-2.5 rounded-lg font-bold text-sm transition-all flex items-center gap-2 ${
              activeTab === "settings" 
                ? "bg-white text-indigo-600 shadow-md" 
                : "text-slate-600 hover:text-slate-900"
            }`}
          >
            <Settings size={16} />
            API Configuration
          </button>
        </div>
      </div>

      {/* Alert Notifications */}
      {alert && (
        <div className={`p-4 rounded-xl flex items-center gap-3 border animate-in slide-in-from-top duration-300 ${
          alert.type === "success" 
            ? "bg-emerald-50 text-emerald-800 border-emerald-200" 
            : "bg-rose-50 text-rose-800 border-rose-200"
        }`}>
          {alert.type === "success" ? <CheckCircle size={20} /> : <AlertCircle size={20} />}
          <p className="text-sm font-bold tracking-wide">{alert.text}</p>
        </div>
      )}

      {/* Metrics Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {metrics.map((m, idx) => {
          const Icon = m.icon;
          return (
            <div key={idx} className="bg-white border border-slate-200 rounded-2xl p-6 hover:shadow-lg transition-all group">
              <div className="flex items-center justify-between mb-4">
                <span className="text-sm font-bold text-slate-400 group-hover:text-slate-600 transition-colors uppercase tracking-wider">{m.label}</span>
                <div className={`p-3 rounded-xl transition-colors ${
                  m.color === "indigo" ? "bg-indigo-50 text-indigo-600" :
                  m.color === "emerald" ? "bg-emerald-50 text-emerald-600" :
                  m.color === "rose" ? "bg-rose-50 text-rose-600" : "bg-sky-50 text-sky-600"
                }`}>
                  <Icon size={20} />
                </div>
              </div>
              <h2 className="text-3xl font-black text-slate-900 tracking-tight mb-1">{m.val}</h2>
              <p className={`text-xs font-bold ${
                m.trend.includes("+") ? "text-emerald-600" : "text-slate-500"
              }`}>{m.trend}</p>
            </div>
          );
        })}
      </div>

      {/* TAB 1: COMPOSE PANEL */}
      {activeTab === "compose" && (
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">
          {/* Form Box */}
          <div className="xl:col-span-2 bg-white border border-slate-200 rounded-3xl p-8 shadow-sm">
            <h2 className="text-xl font-black text-slate-900 mb-6 flex items-center gap-2">
              <Send size={20} className="text-indigo-600" />
              Craft & Cast Post
            </h2>

            <div className="space-y-6">
              {/* ✨ AI Copilot Banner Toggle */}
              <div className="bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 rounded-2xl p-4 shadow-sm text-white">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="bg-white/20 p-2 rounded-xl backdrop-blur-sm animate-pulse">
                      <SparklesIcon size={18} className="text-yellow-300" />
                    </div>
                    <div>
                      <h3 className="font-black text-sm tracking-wide uppercase">AI Marketing Architect</h3>
                      <p className="text-xs font-semibold text-white/80">Optimize captions, suggested locations & niches.</p>
                    </div>
                  </div>
                  <button
                    onClick={() => setShowAiHelper(!showAiHelper)}
                    className="bg-white text-indigo-600 hover:bg-indigo-50 font-black text-xs px-4 py-2 rounded-xl transition-all shadow-md active:scale-95"
                  >
                    {showAiHelper ? "Collapse Assistant" : "Summon AI Companion"}
                  </button>
                </div>

                {showAiHelper && (
                  <div className="mt-4 pt-4 border-t border-white/20 space-y-4 animate-in slide-in-from-top duration-300">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-slate-900">
                      <div className="space-y-1">
                        <label className="text-[10px] font-extrabold uppercase text-white/90">Core Campaign Topic / Prompt</label>
                        <input 
                          type="text" 
                          value={aiTopic}
                          onChange={(e) => setAiTopic(e.target.value)}
                          placeholder="e.g. IIT-JEE Live Masterclass Launch" 
                          className="w-full px-3 py-2 rounded-lg bg-white/95 focus:bg-white border-0 outline-none text-sm font-bold"
                        />
                      </div>
                      <div className="space-y-1">
                        <label className="text-[10px] font-extrabold uppercase text-white/90">Target Demographic</label>
                        <select 
                          value={aiAudience}
                          onChange={(e) => setAiAudience(e.target.value)}
                          className="w-full px-3 py-2.5 rounded-lg bg-white/95 focus:bg-white border-0 outline-none text-sm font-bold cursor-pointer"
                        >
                          <option>Competitive Exam Aspirants</option>
                          <option>School Students (K-12)</option>
                          <option>Professional IT Upskilling</option>
                          <option>EdTech Decision-Making Parents</option>
                          <option>University Graduates</option>
                        </select>
                      </div>
                    </div>
                    
                    <button
                      onClick={handleGetAISuggestions}
                      disabled={aiLoading}
                      className="w-full bg-yellow-400 hover:bg-yellow-300 text-indigo-900 font-black text-sm py-2.5 rounded-xl transition-all flex items-center justify-center gap-2 active:scale-95"
                    >
                      {aiLoading ? <div className="w-4 h-4 border-2 border-indigo-900 border-t-transparent rounded-full animate-spin" /> : "✨ Formulate Optimized Strategy"}
                    </button>

                    {aiSuggestions && (
                      <div className="bg-white/95 rounded-xl p-4 space-y-3 text-slate-800 border border-white/20 animate-in fade-in duration-300">
                        <div className="space-y-1">
                          <div className="flex items-center justify-between">
                            <span className="text-[10px] font-black uppercase text-indigo-600">🔥 ENGAGEMENT CAPTION</span>
                            <button 
                              onClick={() => setMessage(aiSuggestions.suggested_caption)}
                              className="text-[10px] font-black uppercase px-2 py-0.5 bg-indigo-100 text-indigo-700 hover:bg-indigo-200 rounded"
                            >
                              Inject to Post
                            </button>
                          </div>
                          <p className="text-xs font-bold text-slate-700 bg-slate-50 p-2 rounded-lg border leading-relaxed border-dashed border-slate-300">{aiSuggestions.suggested_caption}</p>
                        </div>
                        <div className="grid grid-cols-2 gap-3 pt-1">
                          <div className="space-y-1">
                            <span className="text-[10px] font-black uppercase text-indigo-600">📍 TARGET LOCATIONS</span>
                            <div className="flex flex-wrap gap-1">
                              {aiSuggestions.suggested_locations?.map((loc, i) => (
                                <span key={i} className="text-[10px] font-bold bg-teal-50 text-teal-700 border border-teal-100 px-2 py-0.5 rounded-full">{loc}</span>
                              ))}
                            </div>
                          </div>
                          <div className="space-y-1">
                            <span className="text-[10px] font-black uppercase text-indigo-600">🎯 INTEREST AREAS</span>
                            <div className="flex flex-wrap gap-1">
                              {aiSuggestions.marketing_areas?.map((area, i) => (
                                <span key={i} className="text-[10px] font-bold bg-rose-50 text-rose-700 border border-rose-100 px-2 py-0.5 rounded-full">{area}</span>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Text Area */}
              <div className="space-y-2">
                <label className="block text-sm font-extrabold text-slate-700">Caption / Post Message</label>
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Share announcements, high performing videos, or visual content natively to all streams at once..."
                  rows={6}
                  className="w-full px-4 py-3 rounded-xl border-2 border-slate-100 bg-slate-50 focus:bg-white focus:border-indigo-500 font-semibold text-slate-800 outline-none transition-all"
                />
              </div>

              {/* File Selector */}
              <div className="space-y-2">
                <label className="block text-sm font-extrabold text-slate-700">Attach High-Fi Media (Image/Video)</label>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-center">
                  <label className="relative flex flex-col items-center justify-center border-2 border-dashed border-slate-300 hover:border-indigo-500 rounded-2xl p-6 bg-slate-50 hover:bg-indigo-50/30 cursor-pointer transition-all h-48 group">
                    <input type="file" accept="image/*,video/*" className="hidden" onChange={handleMediaChange} />
                    {selectedMedia ? (
                      <div className="text-center">
                        <div className="p-3 bg-indigo-100 text-indigo-700 rounded-full inline-block mb-2">
                          {selectedMedia.type.startsWith("image") ? <ImageIcon size={24} /> : <Video size={24} />}
                        </div>
                        <p className="font-bold text-slate-800 text-sm line-clamp-1 px-4">{selectedMedia.name}</p>
                        <p className="text-xs font-medium text-slate-500 mt-1">Click to replace media</p>
                      </div>
                    ) : (
                      <div className="flex flex-col items-center group-hover:scale-105 transition-transform">
                        <div className="p-3 bg-white shadow-sm rounded-2xl border border-slate-100 text-slate-400 mb-3">
                          <ImageIcon size={28} />
                        </div>
                        <span className="font-extrabold text-sm text-slate-700">Drag & Drop or Browse File</span>
                        <span className="text-xs text-slate-400 font-semibold mt-1">Supports PNG, JPG, MP4 up to 100MB</span>
                      </div>
                    )}
                  </label>

                  {/* Preview Pane */}
                  <div className="border-2 border-slate-100 rounded-2xl h-48 flex items-center justify-center bg-slate-50 overflow-hidden relative">
                    {mediaPreview ? (
                      selectedMedia?.type.startsWith("image") ? (
                        <img src={mediaPreview} alt="Preview" className="w-full h-full object-cover" />
                      ) : (
                        <video src={mediaPreview} className="w-full h-full object-cover" controls />
                      )
                    ) : (
                      <div className="text-center text-slate-300 font-extrabold text-sm uppercase tracking-widest">No Attachment Preview</div>
                    )}
                    {mediaPreview && (
                      <button 
                        onClick={() => { setSelectedMedia(null); setMediaPreview(null); }} 
                        className="absolute top-2 right-2 bg-black/60 text-white p-1.5 rounded-full hover:bg-rose-600"
                      >
                        <AlertCircle size={14} />
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {/* Channel Selector Row */}
              <div className="space-y-3">
                <label className="block text-sm font-extrabold text-slate-700">Dispatch Channels</label>
                <div className="grid grid-cols-2 sm:grid-cols-4 xl:grid-cols-7 gap-3">
                  {[
                    { id: "twitter", label: "Twitter / X", icon: TwitterIcon, color: "bg-slate-950 text-white", border: "border-slate-900" },
                    { id: "facebook", label: "Facebook", icon: FacebookIcon, color: "bg-[#1877F2] text-white", border: "border-[#166fe5]" },
                    { id: "linkedin", label: "LinkedIn", icon: LinkedinIcon, color: "bg-[#0077B5] text-white", border: "border-[#006396]" },
                    { id: "instagram", label: "Instagram", icon: InstagramIcon, color: "bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF] text-white", border: "border-[#DD2A7B]" },
                    { id: "youtube", label: "YouTube", icon: YoutubeIcon, color: "bg-[#FF0000] text-white", border: "border-[#cc0000]" },
                    { id: "whatsapp", label: "WhatsApp", icon: WhatsappIcon, color: "bg-[#25D366] text-white", border: "border-[#1da851]" },
                    { id: "google", label: "Google Biz", icon: GoogleIcon, color: "bg-white border-slate-200 hover:border-[#4285F4] text-[#4285F4]", border: "border-[#4285F4]" }
                  ].map((ch) => {
                    const Icon = ch.icon;
                    const active = selectedChannels.includes(ch.id);
                    const enabled = configs[ch.id]?.enabled;
                    return (
                      <button
                        key={ch.id}
                        disabled={!enabled}
                        onClick={() => toggleChannel(ch.id)}
                        className={`flex flex-col items-center p-4 rounded-2xl border-2 transition-all text-center relative overflow-hidden ${
                          !enabled ? "opacity-40 bg-slate-100 cursor-not-allowed border-slate-200" :
                          active ? `${ch.color} ${ch.border} shadow-lg scale-105` : "bg-white border-slate-200 hover:border-slate-400 text-slate-700"
                        }`}
                      >
                        <Icon size={24} className="mb-2" />
                        <span className="font-black text-xs uppercase tracking-wider">{ch.label}</span>
                        {!enabled && <span className="absolute inset-x-0 top-0 py-0.5 text-[8px] bg-slate-500 text-white font-black tracking-widest uppercase">Disabled</span>}
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* 📢 Ad Campaign Console */}
              <div className="border-2 border-slate-100 hover:border-slate-200 bg-slate-50/50 rounded-2xl p-6 space-y-4 transition-all">
                <div className="flex items-center justify-between border-b border-slate-200/50 pb-3">
                  <div className="flex items-center gap-3">
                    <div className="bg-emerald-100 text-emerald-700 p-2.5 rounded-xl">
                      <Eye size={20} />
                    </div>
                    <div>
                      <h3 className="font-black text-base tracking-tight text-slate-800">Boost Content With Ad Campaign</h3>
                      <p className="text-xs font-bold text-slate-400">Fund & scale this asset natively on Meta Ads & Google Business.</p>
                    </div>
                  </div>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input 
                      type="checkbox" 
                      checked={isAdCampaign}
                      onChange={(e) => setIsAdCampaign(e.target.checked)}
                      className="sr-only peer" 
                    />
                    <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-600"></div>
                  </label>
                </div>

                {isAdCampaign && (
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2 animate-in slide-in-from-top duration-300">
                    <div className="space-y-1.5">
                      <label className="text-xs font-black text-slate-600 uppercase tracking-wider flex justify-between">
                        <span>Daily Ad Budget</span>
                        <span className="text-emerald-600">INR {adBudget}/day</span>
                      </label>
                      <input 
                        type="range" 
                        min={100} 
                        max={5000} 
                        step={100}
                        value={adBudget}
                        onChange={(e) => setAdBudget(Number(e.target.value))}
                        className="w-full h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-emerald-600"
                      />
                      <div className="flex justify-between text-[10px] font-bold text-slate-400">
                        <span>₹100</span>
                        <span>₹2500</span>
                        <span>₹5000</span>
                      </div>
                    </div>

                    <div className="space-y-1.5">
                      <label className="text-xs font-black text-slate-600 uppercase tracking-wider flex justify-between">
                        <span>Campaign Duration</span>
                        <span className="text-indigo-600">{adDuration} Days</span>
                      </label>
                      <input 
                        type="range" 
                        min={1} 
                        max={30} 
                        value={adDuration}
                        onChange={(e) => setAdDuration(Number(e.target.value))}
                        className="w-full h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-indigo-600"
                      />
                      <div className="flex justify-between text-[10px] font-bold text-slate-400">
                        <span>1 Day</span>
                        <span>15 Days</span>
                        <span>30 Days</span>
                      </div>
                    </div>

                    {aiSuggestions && (
                      <div className="sm:col-span-2 bg-white p-3 rounded-xl border border-slate-200/60 space-y-2">
                        <p className="text-xs font-black text-indigo-600 uppercase tracking-widest">🧬 Automatically Inherited Ad Target Settings</p>
                        <div className="grid grid-cols-2 gap-4 text-[11px]">
                          <div>
                            <span className="font-extrabold text-slate-400">LOCATIONS ({aiSuggestions.suggested_locations?.length || 0}):</span>
                            <p className="font-bold text-slate-700 leading-tight">{aiSuggestions.suggested_locations?.join(", ")}</p>
                          </div>
                          <div>
                            <span className="font-extrabold text-slate-400">INTEREST NICHES ({aiSuggestions.marketing_areas?.length || 0}):</span>
                            <p className="font-bold text-slate-700 leading-tight">{aiSuggestions.marketing_areas?.join(", ")}</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Submit button */}
              <div className="pt-4">
                <button
                  onClick={handlePublish}
                  disabled={loading}
                  className="w-full bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-700 hover:to-violet-700 text-white font-black text-base tracking-wider uppercase py-4 rounded-2xl shadow-lg shadow-indigo-600/20 hover:shadow-indigo-600/30 flex items-center justify-center gap-3 disabled:opacity-60 transition-all transform active:scale-95"
                >
                  {loading ? (
                    <>
                      <div className="w-5 h-5 border-3 border-white border-t-transparent rounded-full animate-spin" />
                      Broadcasting To Selected Channels...
                    </>
                  ) : (
                    <>
                      <Send size={20} />
                      Launch Unified Campaign
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>

          {/* Feed Simulator Box */}
          <div className="xl:col-span-1 bg-slate-950 text-slate-100 border border-slate-900 rounded-3xl p-6 overflow-hidden flex flex-col h-[fit-content] max-h-[700px] sticky top-6">
            <div className="flex items-center gap-2 mb-6 border-b border-slate-800 pb-4">
              <div className="w-3 h-3 bg-rose-500 rounded-full animate-pulse" />
              <h3 className="text-sm font-black uppercase tracking-widest text-slate-400">Live Content Inspector</h3>
            </div>

            <div className="flex-1 bg-slate-900 rounded-2xl p-4 flex flex-col min-h-[300px]">
              {/* Simulator Header */}
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-indigo-600 rounded-full flex items-center justify-center font-black text-sm text-white">LMS</div>
                <div>
                  <div className="font-extrabold text-sm text-white">Your Academic Hub</div>
                  <div className="text-[10px] text-slate-400 font-bold flex items-center gap-1 uppercase tracking-wider">
                    <Globe size={10} /> Just now • Unified API API Broadcast
                  </div>
                </div>
              </div>
              
              {/* Simulator Body */}
              <p className="text-sm text-slate-300 leading-relaxed break-words font-medium whitespace-pre-wrap mb-4">
                {message || "Start typing in the composer terminal to observe the raw rendered graph payload visualization in real time..."}
              </p>

              {/* Simulator Media */}
              {mediaPreview && (
                <div className="flex-1 min-h-[180px] bg-black rounded-xl overflow-hidden">
                  {selectedMedia?.type.startsWith("image") ? (
                            <img src={mediaPreview} alt="Inspector Preview" className="w-full h-full object-contain bg-slate-800" />
                  ) : (
                    <video src={mediaPreview} className="w-full h-full object-cover" muted autoPlay loop />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* TAB 2: API SETTINGS PANEL */}
      {activeTab === "settings" && (
        <div className="bg-white border border-slate-200 rounded-3xl p-8 shadow-sm max-w-4xl mx-auto">
          <div className="flex items-center justify-between gap-4 border-b border-slate-100 pb-6 mb-8">
            <div>
              <h2 className="text-xl font-black text-slate-900 flex items-center gap-2">
                <Settings size={22} className="text-indigo-600" />
                Graph API Configuration Portal
              </h2>
              <p className="text-sm font-semibold text-slate-400 mt-1">Provision secure tokens and IDs for external network integrations.</p>
            </div>
            <button
              onClick={handleSaveConfig}
              disabled={configLoading}
              className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-2.5 rounded-xl text-sm font-extrabold transition-all shadow-md disabled:opacity-50 flex items-center gap-2 active:scale-95"
            >
              {configLoading ? <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" /> : "Persist Credentials"}
            </button>
          </div>

          <div className="space-y-8">
            {/* TWITTER */}
            <div className="border border-slate-200 rounded-2xl p-6 space-y-4">
              <div className="flex items-center justify-between border-b border-slate-100 pb-3">
                <div className="flex items-center gap-3">
                  <TwitterIcon size={20} className="text-slate-950" />
                  <span className="font-black uppercase tracking-wide text-slate-800">Twitter / X Integration</span>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={configs.twitter.enabled}
                    onChange={(e) => setConfigs({...configs, twitter: {...configs.twitter, enabled: e.target.checked}})}
                    className="sr-only peer" 
                  />
                  <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-slate-900"></div>
                </label>
              </div>
              {configs.twitter.enabled && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2 animate-in slide-in-from-top-2 duration-200">
                  <div className="space-y-1">
                    <label className="text-xs font-extrabold text-slate-500 uppercase">Twitter API Key</label>
                    <input type="password" value={configs.twitter.api_key} onChange={(e) => setConfigs({...configs, twitter: {...configs.twitter, api_key: e.target.value}})} className="w-full px-3 py-2 border rounded-lg text-sm font-bold" placeholder="API Token client key" />
                  </div>
                  <div className="space-y-1">
                    <label className="text-xs font-extrabold text-slate-500 uppercase">Twitter API Secret</label>
                    <input type="password" value={configs.twitter.api_secret} onChange={(e) => setConfigs({...configs, twitter: {...configs.twitter, api_secret: e.target.value}})} className="w-full px-3 py-2 border rounded-lg text-sm font-bold" placeholder="Consumer client secret" />
                  </div>
                </div>
              )}
            </div>

            {/* FACEBOOK */}
            <div className="border border-slate-200 rounded-2xl p-6 space-y-4">
              <div className="flex items-center justify-between border-b border-slate-100 pb-3">
                <div className="flex items-center gap-3">
                  <FacebookIcon size={20} className="text-[#1877F2]" />
                  <span className="font-black uppercase tracking-wide text-slate-800">Facebook Pages Integration</span>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={configs.facebook.enabled}
                    onChange={(e) => setConfigs({...configs, facebook: {...configs.facebook, enabled: e.target.checked}})}
                    className="sr-only peer" 
                  />
                  <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                </label>
              </div>
              {configs.facebook.enabled && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2 animate-in slide-in-from-top-2 duration-200">
                  <div className="space-y-1">
                    <label className="text-xs font-extrabold text-slate-500 uppercase">Page ID</label>
                    <input type="text" value={configs.facebook.page_id} onChange={(e) => setConfigs({...configs, facebook: {...configs.facebook, page_id: e.target.value}})} className="w-full px-3 py-2 border rounded-lg text-sm font-bold" placeholder="Target Meta Page ID" />
                  </div>
                  <div className="space-y-1">
                    <label className="text-xs font-extrabold text-slate-500 uppercase">Page Access Token</label>
                    <input type="password" value={configs.facebook.page_access_token} onChange={(e) => setConfigs({...configs, facebook: {...configs.facebook, page_access_token: e.target.value}})} className="w-full px-3 py-2 border rounded-lg text-sm font-bold" placeholder="EAAC..." />
                  </div>
                </div>
              )}
            </div>

            {/* LINKEDIN */}
            <div className="border border-slate-200 rounded-2xl p-6 space-y-4">
              <div className="flex items-center justify-between border-b border-slate-100 pb-3">
                <div className="flex items-center gap-3">
                  <LinkedinIcon size={20} className="text-[#0077B5]" />
                  <span className="font-black uppercase tracking-wide text-slate-800">LinkedIn Marketing Graph</span>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={configs.linkedin.enabled}
                    onChange={(e) => setConfigs({...configs, linkedin: {...configs.linkedin, enabled: e.target.checked}})}
                    className="sr-only peer" 
                  />
                  <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-sky-700"></div>
                </label>
              </div>
              {configs.linkedin.enabled && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2 animate-in slide-in-from-top-2 duration-200">
                  <div className="space-y-1">
                    <label className="text-xs font-extrabold text-slate-500 uppercase">Organization URN / ID</label>
                    <input type="text" value={configs.linkedin.organization_id} onChange={(e) => setConfigs({...configs, linkedin: {...configs.linkedin, organization_id: e.target.value}})} className="w-full px-3 py-2 border rounded-lg text-sm font-bold" placeholder="urn:li:organization:..." />
                  </div>
                  <div className="space-y-1">
                    <label className="text-xs font-extrabold text-slate-500 uppercase">OAuth Access Token</label>
                    <input type="password" value={configs.linkedin.access_token} onChange={(e) => setConfigs({...configs, linkedin: {...configs.linkedin, access_token: e.target.value}})} className="w-full px-3 py-2 border rounded-lg text-sm font-bold" placeholder="AQ..." />
                  </div>
                </div>
              )}
            </div>

            {/* INSTAGRAM */}
            <div className="border border-slate-200 rounded-2xl p-6 space-y-4">
              <div className="flex items-center justify-between border-b border-slate-100 pb-3">
                <div className="flex items-center gap-3">
                  <InstagramIcon size={20} className="text-[#E1306C]" />
                  <span className="font-black uppercase tracking-wide text-slate-800">Instagram Business Graph</span>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={configs.instagram.enabled}
                    onChange={(e) => setConfigs({...configs, instagram: {...configs.instagram, enabled: e.target.checked}})}
                    className="sr-only peer" 
                  />
                  <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-gradient-to-tr peer-checked:from-[#F58529] peer-checked:via-[#DD2A7B] peer-checked:to-[#8134AF]"></div>
                </label>
              </div>
              {configs.instagram.enabled && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2 animate-in slide-in-from-top-2 duration-200">
                  <div className="space-y-1">
                    <label className="text-xs font-extrabold text-slate-500 uppercase">Business Account ID</label>
                    <input type="text" value={configs.instagram.business_account_id} onChange={(e) => setConfigs({...configs, instagram: {...configs.instagram, business_account_id: e.target.value}})} className="w-full px-3 py-2 border rounded-lg text-sm font-bold" placeholder="Meta Instagram Business ID" />
                  </div>
                  <div className="space-y-1">
                    <label className="text-xs font-extrabold text-slate-500 uppercase">Graph Access Token</label>
                    <input type="password" value={configs.instagram.access_token} onChange={(e) => setConfigs({...configs, instagram: {...configs.instagram, access_token: e.target.value}})} className="w-full px-3 py-2 border rounded-lg text-sm font-bold" placeholder="IG Token..." />
                  </div>
                </div>
              )}
            </div>

            {/* YOUTUBE */}
            <div className="border border-slate-200 rounded-2xl p-6 space-y-4">
              <div className="flex items-center justify-between border-b border-slate-100 pb-3">
                <div className="flex items-center gap-3">
                  <YoutubeIcon size={20} className="text-[#FF0000]" />
                  <span className="font-black uppercase tracking-wide text-slate-800">YouTube Data Suite</span>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={configs.youtube.enabled}
                    onChange={(e) => setConfigs({...configs, youtube: {...configs.youtube, enabled: e.target.checked}})}
                    className="sr-only peer" 
                  />
                  <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-red-600"></div>
                </label>
              </div>
              {configs.youtube.enabled && (
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-2 animate-in slide-in-from-top-2 duration-200">
                  <div className="space-y-1">
                    <label className="text-xs font-extrabold text-slate-500 uppercase">OAuth Client ID</label>
                    <input type="text" value={configs.youtube.client_id} onChange={(e) => setConfigs({...configs, youtube: {...configs.youtube, client_id: e.target.value}})} className="w-full px-3 py-2 border rounded-lg text-sm font-bold" placeholder="client_id.apps.googleusercontent.com" />
                  </div>
                  <div className="space-y-1">
                    <label className="text-xs font-extrabold text-slate-500 uppercase">OAuth Client Secret</label>
                    <input type="password" value={configs.youtube.client_secret} onChange={(e) => setConfigs({...configs, youtube: {...configs.youtube, client_secret: e.target.value}})} className="w-full px-3 py-2 border rounded-lg text-sm font-bold" placeholder="Client Secret Key" />
                  </div>
                  <div className="space-y-1">
                    <label className="text-xs font-extrabold text-slate-500 uppercase">Refresh Token</label>
                    <input type="password" value={configs.youtube.refresh_token} onChange={(e) => setConfigs({...configs, youtube: {...configs.youtube, refresh_token: e.target.value}})} className="w-full px-3 py-2 border rounded-lg text-sm font-bold" placeholder="OAuth Refresh Token" />
                  </div>
                </div>
              )}
            </div>

            {/* WHATSAPP */}
            <div className="border border-slate-200 rounded-2xl p-6 space-y-4">
              <div className="flex items-center justify-between border-b border-slate-100 pb-3">
                <div className="flex items-center gap-3">
                  <WhatsappIcon size={20} className="text-[#25D366]" />
                  <span className="font-black uppercase tracking-wide text-slate-800">WhatsApp Business Cloud</span>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={configs.whatsapp.enabled}
                    onChange={(e) => setConfigs({...configs, whatsapp: {...configs.whatsapp, enabled: e.target.checked}})}
                    className="sr-only peer" 
                  />
                  <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-500"></div>
                </label>
              </div>
              {configs.whatsapp.enabled && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2 animate-in slide-in-from-top-2 duration-200">
                  <div className="space-y-1">
                    <label className="text-xs font-extrabold text-slate-500 uppercase">Phone Number ID</label>
                    <input type="text" value={configs.whatsapp.phone_number_id} onChange={(e) => setConfigs({...configs, whatsapp: {...configs.whatsapp, phone_number_id: e.target.value}})} className="w-full px-3 py-2 border rounded-lg text-sm font-bold" placeholder="Business API Phone ID" />
                  </div>
                  <div className="space-y-1">
                    <label className="text-xs font-extrabold text-slate-500 uppercase">Cloud Access Token</label>
                    <input type="password" value={configs.whatsapp.access_token} onChange={(e) => setConfigs({...configs, whatsapp: {...configs.whatsapp, access_token: e.target.value}})} className="w-full px-3 py-2 border rounded-lg text-sm font-bold" placeholder="EAAD..." />
                  </div>
                </div>
              )}
            </div>

            {/* GOOGLE BUSINESS */}
            <div className="border border-slate-200 rounded-2xl p-6 space-y-4">
              <div className="flex items-center justify-between border-b border-slate-100 pb-3">
                <div className="flex items-center gap-3">
                  <GoogleIcon size={20} className="text-[#4285F4]" />
                  <span className="font-black uppercase tracking-wide text-slate-800">Google Business Profile</span>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={configs.google.enabled}
                    onChange={(e) => setConfigs({...configs, google: {...configs.google, enabled: e.target.checked}})}
                    className="sr-only peer" 
                  />
                  <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-500"></div>
                </label>
              </div>
              {configs.google.enabled && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2 animate-in slide-in-from-top-2 duration-200">
                  <div className="space-y-1">
                    <label className="text-xs font-extrabold text-slate-500 uppercase">Location ID / Path</label>
                    <input type="text" value={configs.google.location_id} onChange={(e) => setConfigs({...configs, google: {...configs.google, location_id: e.target.value}})} className="w-full px-3 py-2 border rounded-lg text-sm font-bold" placeholder="accounts/*/locations/*" />
                  </div>
                  <div className="space-y-1">
                    <label className="text-xs font-extrabold text-slate-500 uppercase">Maps Platform API Key</label>
                    <input type="password" value={configs.google.api_key} onChange={(e) => setConfigs({...configs, google: {...configs.google, api_key: e.target.value}})} className="w-full px-3 py-2 border rounded-lg text-sm font-bold" placeholder="AIzaSy..." />
                  </div>
                </div>
              )}
            </div>

          </div>
        </div>
      )}
    </div>
  );
}
